import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@/lib/analytics';

/**
 * Fires a `pageview` analytics event whenever the route path changes.
 * Mount this once inside the Router (see AppRouter).
 */
export function usePageviewTracking(): void {
  const location = useLocation();

  useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname]);
}
